// extracted by mini-css-extract-plugin
export default {"gridTable":"gridTable-wOV44","cell":"cell-SSSaq","noDataMessage":"noDataMessage-xQZCE"};